import { updates } from '@/mocks/home';

const tagColorMap: Record<string, string> = {
  '今日上新': 'bg-accent-500 text-background-50',
  '专题上线': 'bg-primary-500 text-background-50',
  '里程碑': 'bg-primary-500 text-background-50',
  '系统升级': 'bg-secondary-500 text-background-50',
  '新专区': 'bg-accent-500 text-background-50',
  '功能优化': 'bg-secondary-500 text-background-50',
  '内容扩充': 'bg-primary-500 text-background-50',
  '新功能': 'bg-accent-500 text-background-50',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              最新动态
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              平台快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              蓝莓影院的最新更新与重要动态
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-6">
              {updates.map((item) => (
                <div key={item.id} className="relative flex gap-5 pl-12">
                  <div className="absolute left-[15px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100"></div>
                  <div className="flex-1 bg-background-50 rounded-xl p-5 border border-background-200/70">
                    <div className="flex flex-wrap items-center gap-3 mb-2">
                      <span className="text-xs text-foreground-400">{item.date}</span>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${tagColorMap[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}